import { buildQueryString, request, serializeCsvQuery } from "../../client"

const compactIds = (ids?: string[]) =>
  Array.from(new Set((ids ?? []).map((id) => `${id ?? ""}`.trim()).filter(Boolean)))

export const fetchContactPoints = (query?: ContactPointQuery) =>
  request<ContactPoint[]>(
    `/customer-registry/contact-points${buildQueryString({
      organization_id: query?.organizationId,
      customer_id: query?.customerId,
      customer_ids: serializeCsvQuery(query?.customerIds),
      property_id: query?.propertyId,
      property_ids: serializeCsvQuery(query?.propertyIds),
    })}`,
  )

export const searchContactPoints = (query: ContactPointSearchQuery) =>
  request<ContactPoint[]>("/customer-registry/contact-points/search", {
    method: "POST",
    body: JSON.stringify({
      organization_id: query.organizationId,
      customer_ids: compactIds(query.customerIds),
      property_ids: compactIds(query.propertyIds),
    }),
  })

export type PhoneClassificationReason =
  | "MOBILE"
  | "FIXED_LINE"
  | "AMBIGUOUS"
  | "NON_GEOGRAPHIC"
  | "INVALID"
  | (string & {})

export type PhoneClassificationResponse = {
  suggested_kind: "MOBILE" | "FIXED_LINE"
  normalized_value: string | null
  confidence: "HIGH" | "FALLBACK"
  reason: PhoneClassificationReason
}

export const classifyPhoneNumber = (value: string) =>
  request<PhoneClassificationResponse>("/customer-registry/contact-points/classify-phone", {
    method: "POST",
    body: JSON.stringify({ value }),
  })

export const createContactPoint = (payload: ContactPointCreatePayload) =>
  request<ContactPoint>("/customer-registry/contact-points", {
    method: "POST",
    body: JSON.stringify(payload),
  })

export const updateContactPoint = (contactPointId: string, payload: ContactPointUpdatePayload) =>
  request<ContactPoint>(`/customer-registry/contact-points/${contactPointId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  })

export const deleteContactPoint = (contactPointId: string) =>
  request<void>(`/customer-registry/contact-points/${contactPointId}`, { method: "DELETE" })
